import CollapseRankInstitution from "Benchmarking/Components/CollapseRankInstitution";
import { IconPack } from "Benchmarking/Config/Icons";
import "Benchmarking/Scss/RankInstitution.scss";
import { getInstitutionRank } from "Benchmarking/Services/Institution";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSearchParams } from "react-router-dom";

const RankInstitution = () => {
  const [searchParams] = useSearchParams();
  const selectedKeywordsSetup = searchParams
    .get("keywords")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const selectedStateSetup = searchParams
    .get("states")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const selectedInstitutionSetup = searchParams
    .get("institutions")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const timeRangeSetup = searchParams.get("time_range");
  const hbcuSetup = searchParams.get("hbcu");
  const hsiSetup = searchParams.get("hsi");
  const msiSetup = searchParams.get("msi");
  const womenSetup = searchParams.get("womens");
  const tribalSetup = searchParams.get("tribal");
  console.log(selectedStateSetup);
  const [filters, setFilters] = useState({
    keywords: selectedKeywordsSetup ? selectedKeywordsSetup : [],
    states: selectedStateSetup ? selectedStateSetup : [],
    time_range: timeRangeSetup ? timeRangeSetup : "",
    institutions: selectedInstitutionSetup ? selectedInstitutionSetup : [],
    hbcu: hbcuSetup == 1 ? 1 : 0,
    hsi: hsiSetup == 1 ? 1 : 0,
    msi: msiSetup == 1 ? 1 : 0,
    womens: womenSetup == 1 ? 1 : 0,
    tribal: tribalSetup == 1 ? 1 : 0,
  });

  useEffect(() => {
    console.log(filters);
  }, [filters]);
  const [rankData, setRankData] = useState([]);
  const [copyLink, setCopyLink] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setRankData([]);
    getInstitutionRank(filters, (res) => {
      setRankData(res);
      setIsLoading(false);
    });
  }, [filters]);

  const handleCopyToClipBoard = () => {
    let url_link = "http://103.3.245.20:5005/benchmarking/institution/rank?";
    if (filters["keywords"]) {
      url_link += "keywords=";
      filters["keywords"].map((item) => {
        const newStr = item.replace(/ /g, "_");
        url_link += newStr + "-";
      });
      url_link += "&";
    }
    if (filters["time_range"]) {
      url_link += `time_range=${filters["time_range"]}&`;
    }
    if (filters["states"]) {
      url_link += "states=";
      filters["states"].map((item) => {
        const newStr = item.replace(/ /g, "_");
        url_link += newStr + "-";
      });
      url_link += "&";
    }
    if (filters["hbcu"]) {
      url_link += `hbcu=${filters["hbcu"]}&`;
    }
    if (filters["hsi"]) {
      url_link += `hsi=${filters["hsi"]}&`;
    }
    if (filters["msi"]) {
      url_link += `msi=${filters["msi"]}&`;
    }
    if (filters["womens"]) {
      url_link += `womens=${filters["womens"]}&`;
    }
    if (filters["tribal"]) {
      url_link += `tribal=${filters["tribal"]}&`;
    }
    return url_link;
  };
  return (
    <div className="rank-institution scroll-section">
      <CollapseRankInstitution
        filters={filters}
        setFilters={setFilters}
        rankData={rankData}
        isLoading={isLoading}
      />
      <div className="save-button">
        <CopyToClipboard text={handleCopyToClipBoard()}>
          <Tooltip title={copyLink == false ? "Copy link" : "Copied"}>
            <div className="copy-link" onClick={() => setCopyLink(true)}>
              {IconPack.copy_link}
            </div>
          </Tooltip>
        </CopyToClipboard>
        <button>Save</button>
      </div>
    </div>
  );
};

export default RankInstitution;
